"use client";

import * as React from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { DialogClose } from "@radix-ui/react-dialog";

interface ReprovalModalProps {
  id: string;
  onConfirm: (id: string) => void;
  onClose: () => void;
}

export function ReprovalModal({ id, onConfirm, onClose }: ReprovalModalProps) {
  const [open, setOpen] = React.useState(false);

  const handleConfirm = () => {
    onConfirm(id);
    setOpen(false);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          type="button"
          className="bg-transparent border border-black/20 text-black rounded-md font-semibold text-sm p-2 px-4 flex items-center gap-2 hover:bg-black/10"
        >
          Reprovar Query
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[595px] bg-white">
        <DialogHeader>
          <DialogTitle>Tem Certeza?</DialogTitle>
          <DialogDescription>
            Ao recusar esta query, ela não será executada no banco de dados, mas
            será registrada para fins de análise e auditoria futuras. Além
            disso, se algum comentário foi adicionado, ele será devolvido ao
            criador para revisão.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose>
            <Button className="bg-transparent border border-black/20 text-black rounded-md font-semibold text-sm p-2 px-4 flex items-center gap-2 hover:bg-black/10">
              Cancelar
            </Button>
          </DialogClose>
          <Button
            type="button"
            onClick={handleConfirm}
            className="bg-[#FFCC32] text-black rounded-md font-semibold text-sm p-2 px-4 flex items-center gap-2 hover:[#FFCC32]/80"
          >
            Reprovar Query
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
